import React, { useEffect, useCallback, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import FormFieldError from '../../FormFieldError'

import './index.scss'

const Checkbox = ({
                    children,
                    checked,
                    disabled,
                    id,
                    label,
                    input,
                    meta,
                    name,
                    onChange,
                    onChecked,
                    small,
                    value,
                  }) => {
  const [isChecked, setIsChecked] = useState(checked)
  const inputRef = useRef()

  const inputId = id || name || (input && input.name)

  const handleChange = useCallback((e) => {
    if (onChange) onChange(inputRef.current.checked)
    if (input && input.onChange) input.onChange(e)
    setIsChecked(inputRef.current.checked)
  }, [input, onChange])

  useEffect(()=> {
    setIsChecked(checked)
  }, [checked])

  return (
    <div>
      <div className={classnames({
        'ccbx-checkbox-small': small,
      }, 'ccbx-checkbox', 'd-inline-block')}>
        <div className='align-items-center d-flex'>
          <label className={classnames({
            'font-small': small,
          }, 'align-items-center checkbox-container d-flex')} htmlFor={id}>
            {label || '\u00A0'}
            <input
              checked={isChecked}
              disabled={disabled || meta.submitting}
              id={inputId}
              name={name}
              type='checkbox'
              value={value}
              {...input}
              onChange={handleChange}
              ref={inputRef}
            />
            <span className='checkmark' />
          </label>
        </div>
      </div>

      <FormFieldError {...meta} />

      {typeof children === 'function' && (
        <div>{children((inputRef.current && inputRef.current.checked) || isChecked)}</div>
      )}

      {typeof onChecked === 'function' && isChecked && <div>{onChecked()}</div>}
    </div>
  )
}

Checkbox.propTypes = {
  children: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.node]),
  // eslint-disable-next-line react/forbid-prop-types
  input: PropTypes.object,
  meta: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onChecked: PropTypes.func,
  small: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
}

Checkbox.defaultProps = {
  children: null,
  checked: false,
  disabled: undefined,
  id: undefined,
  label: undefined,
  meta: {},
  input: {},
  name: '',
  onChange: undefined,
  onChecked: undefined,
  small: undefined,
  value: true,
}

export default Checkbox
